import {FC} from 'react'

import {Text} from '@/components/common/content/Text'
import {usePreferences} from '@/components/context/Preferences'
import {getLegalServicePriceListItems} from '@/content/pricing'
import {useServiceCommonContent} from '@/content/service-request/common'
import {useTranslation} from '@/i18n'
import {LegalServiceGroups} from '@/utils/service-request/types'

import {PricingTableLayout} from '../PricingTableLayout'
import {PricingTableSection} from '../PricingTableSection'
import {PricingServiceTableItem} from './PricingServiceTableItem'

type PricingLegalServicesTableProps = {
  title?: string
  subtitle?: string
  note?: string
}

export const PricingLegalServicesTable: FC<
  React.PropsWithChildren<PricingLegalServicesTableProps>
> = ({title, subtitle, note}) => {
  const {t} = useTranslation()
  const {currency} = usePreferences()
  const {simpleServicesTitle, complexServicesTitle} = useServiceCommonContent().pricingTable

  const groups = [
    {title: t(simpleServicesTitle), group: LegalServiceGroups.simple},
    {title: t(complexServicesTitle), group: LegalServiceGroups.complex},
  ]

  return (
    <PricingTableLayout
      title={title}
      subtitle={<Text align="center">{subtitle}</Text>}
      note={note}
      fullWidth
    >
      {groups.map(({title, group}) => (
        <PricingTableSection key={title} title={title}>
          {getLegalServicePriceListItems(group, currency).map(
            ({key, title, description, linkUrl, price}) => (
              <PricingServiceTableItem
                key={key}
                title={t(title)}
                description={t(description)}
                linkUrl={linkUrl}
                price={price}
              />
            ),
          )}
        </PricingTableSection>
      ))}
    </PricingTableLayout>
  )
}
